module.exports = __webpack_public_path__ + "static/img/product-photo.ca5c218.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/imgs/product-photo.jpg
// module id = lOIg
// module chunks = 65